export const ListCardPlaceholder = () => (
  <div
    className="w-100 d-flex placeholder-glow my-3 bg-white rounded-8"
    aria-hidden
  >
    <div className="car-list-card-image-container position-relative">
      <div className="bg-dark placeholder car-list-card-image" />
    </div>
    <div className="placeholder-glow px-3 py-3 w-75">
      <div className="placeholder bg-dark col-6 rounded-8 mb-3 d-block" />
      <div className="placeholder bg-dark col-2 rounded-8 mb-3 d-block" />
      <div className="placeholder bg-dark col-4 rounded-8 mb-3 d-block" />
    </div>
  </div>
)
